import { Mail, Phone, MapPin } from "lucide-react";
import { useState, useEffect } from "react";
import LogoFallback from "/assets/img/bubbanlogo.jpg";

export default function ViceMessage({
  logoSrc = LogoFallback,
  accent = "#115e32",
  pageTitle = "Vice Chancellor | Bandarban University",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  return (
    <div className="bg-gray-50 text-gray-800">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-green-600 to-teal-500 text-white py-16 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-4">Message from the Vice Chancellor</h1>
          <p className="text-lg opacity-90">
            Guiding the future with vision, leadership, and integrity.
          </p>
        </div>
      </section>

      {/* VC Profile Section */}
      <section className="max-w-6xl mx-auto py-16 px-6 grid md:grid-cols-2 gap-10 items-center">
        <img
          src="/assets/img/vc-bubban.jpg"
          alt="Vice Chancellor"
          className="rounded-2xl shadow-lg object-cover w-full max-h-[500px]"
        />
        <div>
          <h2 className="text-2xl font-bold mb-4">Professor Dr. Mohammad Mohibullah Siddiquee</h2>
          <p className="text-gray-700 leading-relaxed">
            It is a matter of great privilege to be part of Bandarban University that prepares today’s students to meet the challenges of tomorrow.
			<br/><br/>
			We know that today’s students will become a part of the world’s top companies, they need to be creative and innovative. We cultivate in our students’ right attitude with a blend of extra-ordinary soft skills and hence make their personality impressive so that they become brand ambassadors of not only Bandarban University but also the enterprise with which they get associated.
			<br/><br/>
			As a Vice-Chancellor, I am confident that efforts to excel in the field of higher education and the inculcation of moral values in the students at the University Campus will continue in the future with greater zeal.
			<br/><br/>
			We as a team at Bandarban University strive to prepare students to become better citizens of our country irrespective of their cultural and financial background and contribute to the welfare of society and country’s development.
			<br/><br/>
			Be part of this revolution led by Bandarban University and become the stars of tomorrow.
          </p>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-8">
          <div className="p-6 bg-gray-100 rounded-xl shadow hover:shadow-lg transition">
            <h3 className="text-xl font-semibold mb-2">Vision</h3>
            <p>To become a leading institution of higher learning in Asia.</p>
          </div>
          <div className="p-6 bg-gray-100 rounded-xl shadow hover:shadow-lg transition">
            <h3 className="text-xl font-semibold mb-2">Mission</h3>
            <p>To nurture creativity, research, and leadership through quality education.</p>
          </div>
          <div className="p-6 bg-gray-100 rounded-xl shadow hover:shadow-lg transition">
            <h3 className="text-xl font-semibold mb-2">Goals</h3>
            <p>Expanding research opportunities and strengthening global partnerships.</p>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="bg-gradient-to-r from-teal-600 to-green-600 text-white py-12">
        <div className="max-w-4xl mx-auto px-6 text-center space-y-4">
          <h3 className="text-2xl font-bold mb-4">Office of the Vice Chancellor</h3>
          <div className="flex flex-col md:flex-row justify-center gap-6">
            <div className="flex items-center gap-2">
              <MapPin size={20} /> <span>K.B Road, Shualok, Post Office: Shualok - 4600, Bandarban Sadar, Bangladesh</span>
            </div>
            <div className="flex items-center gap-2">
              <Phone size={20} /> <span>+880 1318-305900</span>
            </div>
            <div className="flex items-center gap-2">
              <Mail size={20} /> <span>vc@bubban.ac.bd</span>
            </div>
          </div>
          <button className="mt-6 px-6 py-3 bg-white text-teal-700 font-semibold rounded-lg shadow hover:bg-gray-100">
            Request Appointment
          </button>
        </div>
      </section>
    </div>
  );
}
